(() => {
  document.querySelectorAll('[data-locale]').forEach((root) => {
    const trigger = root.querySelector('[data-locale-trigger]');
    const panel = root.querySelector('[data-locale-panel]');
    const search = root.querySelector('[data-locale-search]');
    const list = root.querySelector('[data-locale-list]');
    const items = root.querySelectorAll('[data-locale-item]');
    const empty = root.querySelector('[data-locale-empty]');
    const input = root.querySelector('[data-locale-input]');
    const backBtn = root.querySelector('[data-locale-close]');

    if (!trigger || !panel) return;

    const open = () => {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (search) {
        search.value = '';
        filterItems('');
        search.focus();
      } else {
        const active = panel.querySelector('.locale__item--active');
        if (active) {
          active.focus();
          active.scrollIntoView({ block: 'nearest' });
        }
      }
    };

    const close = () => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    };

    const toggle = () => (panel.hidden ? open() : close());

    const filterItems = (q) => {
      const query = q.toLowerCase().trim();
      let visible = 0;
      items.forEach((item) => {
        const name = item.getAttribute('data-name') || '';
        const match = !query || name.includes(query);
        item.hidden = !match;
        if (match) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    };

    const selectCountry = (item) => {
      const code = item.getAttribute('data-value');
      if (!code || !input) return;
      input.value = code;
      const form = input.closest('form');
      if (form) form.submit();
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      toggle();
    });

    if (backBtn) {
      backBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        close();
      });
    }

    if (search) {
      search.addEventListener('input', () => filterItems(search.value));
      search.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.stopPropagation(); close(); }
        if (e.key === 'Enter') e.preventDefault();
      });
    }

    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        selectCountry(item);
      });
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCountry(item);
        }
      });
    });

    list && list.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
      e.preventDefault();
      const visible = Array.from(items).filter((i) => !i.hidden);
      if (!visible.length) return;
      const idx = visible.indexOf(document.activeElement);
      let next;
      if (e.key === 'ArrowDown') {
        next = idx < visible.length - 1 ? visible[idx + 1] : visible[0];
      } else {
        next = idx > 0 ? visible[idx - 1] : visible[visible.length - 1];
      }
      next.focus();
      next.scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', (e) => {
      if (!panel.hidden && !root.contains(e.target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  });
})();
